import { JSONAPI_URLS, URLS } from '../../../consts/endpoints';
import { actions as reduxActions } from '../reducers';
import { getData } from '../../../utils/http';
import { isArray, isDefined, isUndefined } from '../../../utils/isDefined';
import Optional from '../../../utils/optional';
import { actions as loaderReduxActions } from '../../../partials/loader/reducers';
import getFullTableData from '../../../utils/getFullTableData';
import orderBy from 'lodash.orderby';
import { translate } from '../../../i18n/I18nProvider';
import { translateIdentifier, translateValue } from './translateActions';
const getOrders = client => {
  return async dispatch => {
    let orders = [];

    dispatch(loaderReduxActions.startSpinLoader());
    try {
      const QUERY_PARAMS = {
        include: ['created_by', 'client'],
        filter: isDefined(client)
          ? { client_id: { eq: client } }
          : { client_id: { gt: 0 } }
      };

      const data = await getFullTableData(JSONAPI_URLS.ORDERS, QUERY_PARAMS);

      if (isArray(data)) {
        orders = data;
      }

      if (isDefined(client)) {
        const accounts = await getData(
          `${URLS.QUOTE_CLIENTS}/${client}/accounts`
        );

        const customerAccounts = isArray(accounts)
          ? Optional(accounts.find(account => account.model === 'CUSTOMER')).or(
              accounts[0]
            )
          : void 0;

        const externalReference = customerAccounts?.externalReference;

        if (isDefined(externalReference)) {
          const productsData = await getData(
            `${URLS.QUOTE_CLIENTS}/${client}/products?account_reference=${externalReference}`
          );

          if (
            isUndefined(productsData?.error) &&
            isDefined(productsData?.[externalReference])
          ) {
            const mappedOrders = mapOrders(
              orders,
              productsData[externalReference]
            );

            orders = mappedOrders;
          }
        }
      }
      orders = orderBy(
        mapOrdersTypeAndAction(orders),
        ['created_at'],
        ['desc']
      );
    } finally {
      dispatch(reduxActions.setOrders(orders));
      dispatch(loaderReduxActions.stopSpinLoader());
    }
  };
};

export default getOrders;

const mapOrders = (orders, productsData) => {
  if (!isArray(productsData)) {
    return orders;
  }

  const mappedProduct = productsData.map(product => {
    return {
      sku: product.sku,
      name: Optional(product.translations?.sku?.default).or('')
    };
  });

  return orders.map(order => {
    if (order.order_type !== 'subscription') {
      return order;
    }
    const product = mappedProduct.find(
      product => product.sku === order.specification?.sku
    );

    if (isDefined(product)) {
      order.specification.product = Optional(product?.name).or(void 0);

      delete order.specification.sku;
    }

    return {
      ...order,
      productName: Optional(product?.name).or(void 0)
    };
  });
};

const mapOrdersTypeAndAction = orders => {
  return orders.map(order => {
    const { specification } = order;

    const specs = specification[0].specification;

    if (!isArray(specs)) {
      return order;
    }
    let action = [...new Set(specs.map(spec => translateValue(spec.action)))];
    let type = [
      ...new Set(specs.map(spec => translateIdentifier(spec.identifier)))
    ];

    return {
      ...order,
      type,
      action
    };
  });
};
